import { JSXElementConstructor, ReactElement } from "react";

import { Button, IconButton } from "@/storybook-components/";

function ActionButton({
  type,
  icon,
  label,
  onClick,
  "data-testid": testId,
  ...rest
}: {
  type: "button" | "icon";
  icon: ReactElement<any, string | JSXElementConstructor<any>>;
  label: string;
  onClick?: () => void;
  "data-testid"?: string;
} & Record<string, unknown>) {
  if (type === "button") {
    return (
      <Button
        fontSize="md"
        aria-label={label}
        leftIcon={icon}
        onClick={onClick}
        variant="primary"
        fontWeight="semibold"
        size={{ base: "lg", xl: "md" }}
        data-testid={testId}
        {...rest}
      >
        {label}
      </Button>
    );
  }

  return (
    <IconButton
      aria-label={label}
      icon={icon}
      onClick={onClick}
      zIndex={2}
      rounded="full"
      boxShadow="lg"
      color="gray.900"
      background="white"
      variant="solid"
      _hover={{ background: "white" }}
      _focus={{ background: "white" }}
      w={{ base: 10, sm: 12, xl: 10 }}
      h={{ base: 10, sm: 12, xl: 10 }}
      data-testid={testId}
      {...rest}
    />
  );
}

export default ActionButton;
